import { render, staticRenderFns } from "./QuestionOther.vue?vue&type=template&id=c9a846fe&"
import script from "./QuestionOther.vue?vue&type=script&lang=js&"
export * from "./QuestionOther.vue?vue&type=script&lang=js&"
import style0 from "./QuestionOther.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports